let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("1PKKF"), load("C72jX")]).then(() => parcelRequire('5uV65'));